import { render, staticRenderFns } from "./AboutBoard.vue?vue&type=template&id=72812747&"
import script from "./AboutBoard.vue?vue&type=script&lang=js&"
export * from "./AboutBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports